import React from 'react';
import { Text } from '@rneui/themed';
import { StyleSheet } from 'react-native';
import { useTheme } from '../../hooks';
export const Title = ({ text, style = {}, isLoading = false, ...props }) => {
    const theme = useTheme();
    const propKeys = Object.keys(props);
    const fontSizeKeys = Object.keys(theme.fontSizes);
    const defaultH1 = !propKeys
        .some(key => fontSizeKeys.includes(key.toString()));
    return (React.createElement(Text, { style: StyleSheet.flatten([
            {
                textAlign: 'center',
                color: theme.colors.textPrimary,
                marginVertical: 10,
            },
            style,
        ]), bold: true, h1: defaultH1, ...props }, isLoading ? " " : text));
};
//# sourceMappingURL=Title.js.map